import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import KuikaButton from "../../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../../ui-kit/kuika-svg/kuika-svg";

interface IUndoRedoProps {}

const UndoRedo: React.FC<IUndoRedoProps & IWithSDProps> = ({ sd }) => {
  const handleUndo = () => {
    if (sd.canUndo()) {
      sd.undo();
    }
  };

  const handleRedo = () => {
    if (sd.canRedo()) {
      sd.redo();
    }
  };

  return (
    <div className="kuika-flex-center">
      <KuikaButton
        data-testid="headerUndoButton"
        onClick={handleUndo}
        disabled={!sd.canUndo()}
        isIcon
        type="tertiary"
        size="sm"
        data-onboarding-id="topbar-undo"
      >
        <KuikaSvg width={16} height={16} name="arrow-back-up" type="arrows" disabled={!sd.canUndo()} />
      </KuikaButton>
      <KuikaButton
        data-testid="headerRedoButton"
        onClick={handleRedo}
        disabled={!sd.canRedo()}
        isIcon
        type="tertiary"
        size="sm"
        data-onboarding-id="topbar-redo"
      >
        <KuikaSvg width={16} height={16} name="arrow-forward-up" type="arrows" disabled={!sd.canRedo()} />
      </KuikaButton>
    </div>
  );
};

const undoRedo = withSD<IUndoRedoProps>(UndoRedo);
export { undoRedo as UndoRedo };
